import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SuperSidebar from '../components/superadmin/SuperSidebar';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import './Layout.css';

const SuperLayout = () => {
  const { logout } = useAuth();
  const { theme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div className={`super-layout ${theme} ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`} data-theme={theme}>
      <aside className="sidebar-container">
        <SuperSidebar 
          logout={logout} 
          onSidebarToggle={handleSidebarToggle}
        />
      </aside>
      <main className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${window.innerWidth <= 768 ? 'mobile' : ''}`}>
        <div className="content-container">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperLayout;
